(function () {
    'use strict';

    a3_pilot_reports.factory('CrewCallFactory', CrewCallFactory);

    /**
     * @memberof PilotReports
     * @ngdoc factory
     * @name CrewCallFactory
     * @ngInject
     */
    function CrewCallFactory(GenericService, $http, apiUrl) {
        function CrewCall() {
			this.FlightId = null;
            this.CrewId = null;
            this.phoneNumber = null;
		}

        var objType ='crewCall';
		var objCallback = CrewCall; 

        var service = {
            getCrewCallsFromStorage : getCrewCallsFromStorage,
            setCrewCallsToStorage : setCrewCallsToStorage,
            getCrewCallFromStorage : getCrewCallFromStorage,
            getFlightCrewCallsFromStorage : getFlightCrewCallsFromStorage,
            saveCrewCall : saveCrewCall,
            cleanOldData : cleanOldData,
            LogCall: LogCall,
            cleanFlightCrewNumbers : cleanFlightCrewNumbers,
            saveFlightPhoneNumbers : saveFlightPhoneNumbers
        };

         /**
         * Get Crew Phone Numbers.
         * @memberof CrewCallFactory
         * @returns {Array} CrewPhoneNumbers 
         */
		function getCrewCallsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Get Crew Phone Numbers for specified flight
         * @memberof CrewCallFactory
         * @param {number} flightId
         * @returns {Array} CrewPhoneNumbers 
         */
		function getFlightCrewCallsFromStorage(flightId) {
			var phoneNumbers =  GenericService.list(objType,objCallback);
            return phoneNumbers.filter(x => x.FlightId == flightId);
		}

        /**
         * Save Crew Phone Numbers to storage
         * @memberof CrewCallFactory
         * @param {Array} CrewPhoneNumbers
         */
		function setCrewCallsToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }

        /**
         * Get Crew Phone Number from storage 
         * @memberof CrewCallFactory
         * @param {number} crewId
         * @param {number} flightId
         * @return {object} crew phone number
         */
		function getCrewCallFromStorage(crewId, flightId) {
            var phoneNumbers = getCrewCallsFromStorage();

            return phoneNumbers.find(x => x.FlightId == flightId && x.CrewId == crewId);
		}
        
        /**
		 * Save a fetched crew phone number
         * @memberof CrewCallFactory
		 * @param {object} crewCall 
		 */
		function saveCrewCall(crewCall){
            GenericService.add(crewCall, objType, objCallback);
		}

        /**
         * Clean ls from old flight phone numbers
         * @param {array} flights Synced flights
         */
        function cleanOldData(responseFlightIds){
            var phoneNumbers = getCrewCallsFromStorage();
            //Filter out phone numbers of old flights
            phoneNumbers = phoneNumbers.filter(x => responseFlightIds.includes(x.FlightId));
            
            var now = moment.utc();
            var keepingPhoneNumbers = [];
            phoneNumbers.forEach(function(item){

                //Fetch FROM
                //Convert from Date UTC to Moment UTC
                var dateSTD = new Date(item.STD).fromUTC();
                var std = moment(dateSTD).utc();        
                var minFetchTime = moment(std).add(-24, 'hours');

                //Fetch UNTIL
                //Convert from Date UTC to Moment UTC
                var dateSTA = new Date(item.STA).fromUTC();
                var sta = moment(dateSTA).utc();        
                var maxFetchTime = moment(sta).add(2, 'hours');
            
                var isAfter = now.isAfter(minFetchTime);
                var isBefore = now.isBefore(maxFetchTime);

                if(isAfter && isBefore){
                    keepingPhoneNumbers.push(item);
                }
                
            });

            setCrewCallsToStorage(keepingPhoneNumbers);
        }

        /**
         * Log call request
         * @param {string} logData Requester, Requestee, FlightId
         * @param {function} callback 
         * @param {function} errorCallback 
         */
        function LogCall(logData, callback, errorCallback) {
            return $http.post(apiUrl + '/Info/LogCrewMemberCall', logData, { 'Content-Type': 'application/json' })
                .then(callback)
                .catch(errorCallback);
        }

        /**
         * Clean all stored phone numbers for selected flight
         * @param {number} flightId 
         */
        function cleanFlightCrewNumbers(flightId){
            var phoneNumbers = getCrewCallsFromStorage();
			phoneNumbers = phoneNumbers.filter(x => x.FlightId != flightId);
			setCrewCallsToStorage(phoneNumbers);
        }

        /**
         * Save any found crew phone numbers for specified flight
         * @param {number} flightId 
         * @param {array} crew 
         * @param {datetime} sta 
         * @param {datetime} std 
         */
        function saveFlightPhoneNumbers(flightId, crew, sta, std){
            crew.forEach(function(user){
                if(user.PhoneNumber){
                    var crewPhone = {
                        FlightId : flightId,
                        CrewId : user.id,
                        PhoneNumber : user.PhoneNumber,
                        STA : sta,  //sta & std values will be used during sync to check timerange eligibility (-24h sta / +2h std)
                        STD : std
                    };
                    saveCrewCall(crewPhone);
                }
            });
        }


        return service;
    }
})();